import { useQuery } from '@apollo/client/react';

import {
  INSTRUCTOR_TRAINING_SESSIONS,
  TRAINEE_TRAINING_SESSIONS,
  TraineeOrInstructorTrainingSessions,
} from 'src/components/mainComponents/TrainingSessionSelect/queries';
import { TrainingSessionSelectView } from 'src/components/mainComponents/TrainingSessionSelect/TrainingSessionSelectView';
import { useAuth } from 'src/user';

export function TrainingSessionSelect() {
  const { auth } = useAuth();
  const userId = auth?.guestInfo?.id;
  const userType = auth?.guestInfo?.type ?? '';

  const { data: traineeSessions, loading: isLoadingTraineeSessions } = useQuery<TraineeOrInstructorTrainingSessions>(
    TRAINEE_TRAINING_SESSIONS,
    {
      skip: userId === undefined || userType !== 'trainee',
      variables: {
        id: userId,
      },
    }
  );

  const { data: instructorSessions, loading: isLoadingInstructorSessions } = useQuery<TraineeOrInstructorTrainingSessions>(
    INSTRUCTOR_TRAINING_SESSIONS,
    {
      skip: userId === undefined || userType !== 'instructor',
      variables: {
        id: userId,
      },
    }
  );

  const isLoading = isLoadingTraineeSessions || isLoadingInstructorSessions;
  const trainingSessions = traineeSessions || instructorSessions;

  if (isLoading || !trainingSessions || trainingSessions.user.trainingSessions.length === 0) {
    return null;
  }

  return <TrainingSessionSelectView trainingSessions={trainingSessions.user.trainingSessions} />;
}
